<template>
  <div>
    <h1 class="display-1 font-weight-black primary--text mb-2">
      Portal do Beneficiário
    </h1>
    <p class="subheading">Acesso expirado. Crie uma nova senha.</p>
    <v-form ref="form" v-model="valido">
      <v-text-field
        label="E-mail"
        type="text"
        v-model="data.email"
        :disabled="isEmailFieldDisabled"
      ></v-text-field>
      <v-text-field
        required
        label="Senha Atual"
        name="senha"
        type="password"
        v-model="data.senhaAtual"
      ></v-text-field>
      <v-text-field
        required
        label="Nova Senha"
        name="novaSenha"
        type="password"
        v-model="data.novaSenha"
        :rules="passwordRules"
      ></v-text-field>
      <v-text-field
        required
        label="Confirmação de Senha"
        name="senhaConfirmation"
        type="password"
        v-model="data.senhaConfirmation"
        :rules="passwordConfirmation"
      ></v-text-field>
    </v-form>
    <v-spacer></v-spacer>
    <v-layout align-center justify-space-between row fill-height>
      <v-btn
        flat
        color="grey darken-1"
        class="body-2 text-none mx-0 px-1"
        :to="{ name: 'acessar' }"
        >Já tenho o acesso</v-btn
      >
      <v-btn
        light
        class="mr-0"
        data-cy="recoverySubmitBtn"
        :color="highContrast ? 'white' : 'primary'"
        :disabled="!valido"
        @click="enviar"
        >Alterar</v-btn
      >
    </v-layout>
    <p class="mt-4 subheading">
      Primeiro acesso?
      <v-btn
        flat
        color="grey darken-1"
        class="body-2 text-none mx-0 px-1"
        :to="{ name: 'primeiro-acesso' }"
        >Faça seu cadastro novo aqui</v-btn
      >
    </p>
  </div>
</template>

<script>
import auth from "./auth";
import { passwordValidation } from "@/utils/validation-rules";

export default {
  name: "AcessoExpirado",
  props: {
    highContrast: Boolean,
    username: String
  },
  data() {
    return {
      data: {
        email: "",
        senhaAtual: "",
        novaSenha: "",
        senhaConfirmation: ""
      },
      isEmailFieldDisabled: false,
      passwordRules: [
        value => !!value || "A senha é obrigatória",
        value => passwordValidation(value)
      ],
      passwordConfirmation: [
        value => !!value || "A senha é obrigatória",
        value => passwordValidation(value),
        value =>
          value === this.data.novaSenha ||
          "A senha nova a confirmação da senha nova devem ser iguais"
      ],
      valido: false
    };
  },
  created() {
    this.isEmailFieldDisabled = this.checkUsername();
  },
  methods: {
    enviar() {
      if (this.$refs.form.validate()) {
        auth.redefinirSenha(this.data, this.$store, this.$router);
      }
    },
    checkUsername() {
      if (this.username && this.username.includes("@")) {
        this.data.email = this.username;

        return true;
      }

      return false;
    }
  }
};
</script>
